<!--忘记密码-->
<template>
	<div>
		<!-- 忘记密码 -->
		<div class="forgetPassword">
			<div class="innerPassword">
				<span class="spanTitle">找回密码</span>
				<el-input v-model="inputPhone" maxlength="11" type="number"
					oninput="if(value.length>11) value = value.slice(0,11)" placeholder="请输入手机号" class="bigMarginTop newBorder">
				</el-input>
				<el-input placeholder="请输入短信验证码" v-model="inputMsg" class="input-with-select marginTop newBorder">
					<template slot="prepend">验证码</template>
					<el-button slot="append" class="specilBac" @click="sendMsg">{{msgtip}}</el-button>
				</el-input>
				<el-input placeholder="密码长度6-24位，至少包含字母、数字、字符任意两种组合" class="marginTop newBorder" type="password" show-password
					v-model="inputPassword">
				</el-input>
				<!-- <div class="marginTop" style="display: flex;"请填写不少于6位,至少一个字母和一个数字的新密码。>
					<el-input v-model="input" placeholder="请输入验证码" style="width: 286px;"></el-input>
					<div style="width: 130px;height: 38px;margin-left: 20px;border: 1px solid #DBDBDB;">
						77777
					</div>
				</div> -->

				<el-button type="primary" class="bigMarginTop"
					style="width: 100%;background: #158AED;border-radius: 4px;" @click="sendNewCode">确定</el-button>

				<el-button class="bigMarginTop2" style="width: 100%;border-radius: 4px;" @click="$router.go(-1)">返回
				</el-button>

			</div>
		</div>
	</div>
</template>

<script>
	import {
		forgetPassword,
		sendSms,
	} from '../../api/modules/paAdmin.js'
	import {
		vaildte
	} from '../../utils/validate.js'

	export default {
		data() {
			return {
				inputPhone: '',
				inputMsg: '',
				inputPassword: '',
				msgtip: '发送短信',
				daoTime: 300,
				disable: false,

			}
		},
		methods: {
			// 发送验证号
			async sendMsg() {
				const params = {
					phone: this.inputPhone.trim()
				}
				if (!params.phone) {
					this.$message.error('请输入手机号')
					return
				}
				if (!vaildte.isPhone(params.phone)) {
					this.$message.error('请输入正确的手机号')
					return
				}
				if (this.disable) {
					this.$message.error('短信验证码5分钟内只能发送一条，30分钟内有效，如果长时间未收到，请查看是否被短信拦截')
					return
				}
				await sendSms({
					data: params,
					success: (res) => {
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.disable = true
						let timer = setInterval(() => {
							this.daoTime--
							if (this.daoTime == 0) {
								clearInterval(timer);
								this.disable = false
								this.daoTime = 300
							}
							// this.msgtip = this.daoTime + 's后重试'
						}, 1000)
						// setTimeout(()=>{
						// 	clearInterval(timer);
						// 	this.disable = false
						// 	this.msgtip = "发送短信"
						// 	this.daoTime = 60
						// },60000)

					}
				})
			},
			// 修改密码
			async sendNewCode() {
				const params = {
					phone: this.inputPhone,
					phoneCode: this.inputMsg,
					password: this.inputPassword,
					code: ''
				}
				if (!params.phone) {
					this.$message.error('请输入手机号')
					return
				}
				if (!vaildte.isPhone(params.phone)) {
					this.$message.error('请输入正确的手机号')
					return
				}
				if (!params.phoneCode) {
					this.$message.error('请输入验证码')
					return
				}
				if (!params.password) {
					this.$message.error('请输入新密码')
					return
				}
				// 密码验证
				if (params.password.length > 5 && params.password.length < 25) {
					// const rgx = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
					const rgx = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)/
					if (!rgx.test(params.password)) {
						this.$message.error('密码不符合要求')
						return
					}
				} else if(params.password.length > 24){
					this.$message.error('密码长度不超过24位')
					return
				} else{
					this.$message.error('密码长度不低于6位')
					return
				}
				await forgetPassword({
					data: params,
					success: (res) => {
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							this.$router.go(-1)
						}, 3000)
					}
				})
			}
		}
	}
</script>

<style scoped>
	/* 忘记密码 */
	.forgetPassword {
		width: 440px;
		height: 440px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: auto;
		margin-right: auto;
		margin-top: 100px;
	}

	.innerPassword {
		width: 440px;
		height: 440px;
		display: flex;
		flex-flow: column;
		justify-content: flex-start;
		align-items: center;
	}

	.spanTitle {
		width: auto;
		height: 37px;
		font-size: 26px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #015AAA;
		line-height: 37px;
	}

	.bigMarginTop {
		margin-top: 50px;

	}

	.bigMarginTop2 {
		margin-top: 30px;
		margin-left: 0;
	}

	.marginTop {
		margin-top: 20px;
	}
	.newBorder {
		border: 1px solid #DCDFE6;
	}
	/* 修改element原生样式 */
	>>>.el-input-group__prepend {
		border: none;
		background-color: #ffffff;
	}
	
	/* :nth-child(2) */
	>>>.el-input__inner {
		border: none;
	}
	
	>>>.el-input-group__append {
		background-color: #ffffff;
		border: none;
	}
	
	/* 取消element ui input基础样式 */
	>>>input::-webkit-outer-spin-button,
	>>>input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
	
	>>>input[type="number"] {
		-moz-appearance: textfield;
	}
</style>
